import { injectable } from 'inversify';
import { MultipartUploadAdapter } from '@dealroadshow/file-uploader';
import files from '@framework/url/filesUrl';

@injectable()
export default class UploadAdapter extends MultipartUploadAdapter {
  constructor() {
    super({ url: files.getBaseUrl() });
  }
}
